var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7414 17.8231L18.0228 13.2289L19.0551 12.1687L25.5838 18.5252L19.2273 25.0539L18.1671 24.0216L22.7612 19.303L11.9685 19.4472L11.9488 17.9674L22.7414 17.8231Z",
    fill: "#8139D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowFilled);
export default __webpack_public_path__ + "static/media/right-Arrow-filled.22e5d714b2fae1b99435aca5883fea0d.svg";
export { ForwardRef as ReactComponent };